export default __webpack_public_path__ + "static/char-s-52-ko-ba6842c978eea6c8067baefacf09ca87.png";